import BaseModel from "../base_model.js";

class RawProjectHighlightModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "text",
        displayName: this.fieldDisplayName("text"),
        type: "text",
      },
    ]
  }

  i18nScope() {
    return "model.projects.highlight";
  }

}
const ProjectHighlightModel = new RawProjectHighlightModel();

export { RawProjectHighlightModel, ProjectHighlightModel }

